import { GET_AGREEMENT_TYPES, UPDATE_AGREEMENT_TYPES } from './../constants';
import { handleActions } from "redux-actions"

export const agreementTypes  = handleActions(
  {
    [ GET_AGREEMENT_TYPES ]: (state, action) =>  action.payload,
    [ UPDATE_AGREEMENT_TYPES ]: (state, action) =>  {
        const result  = action.payload
        const { id } = result
        const initialValue = []
        const newData = state.reduce((acc, ag) => {
            if (ag.id === id) {
                return [...acc, result]
            } else {
                return [...acc, ag]
            }
        }, initialValue)
        return newData
    }
  }, []
)